import secureStorage from "../../../../core/utils/SecureStorage";
import config from "../../../../core/configs/config.app";


//check2
const BasketStorage = {

  setBasket: (basketModel) => {
    secureStorage.setItem(config.basketModel, basketModel);
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      localStorage.setItem(config.basketModel + "_DEV", basketModel);
    }
  },
  getBasket: () => {
    const result = secureStorage.getItem(config.basketModel);

    if (result == null) {
      
    }
    else {
      
    }

    return result;
  },
  
  setBasketPerson: (basketPersonModel) => {
    secureStorage.setItem(config.basketPersonModel, basketPersonModel);
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      localStorage.setItem(config.basketPersonModel + "_DEV", basketPersonModel);
    }
    },

  getBasketPerson: () => {
    const result = secureStorage.getItem(config.basketPersonModel);
    return result;
  },

  clearBasket: () => {
    //  فعلا در هیچ شرایطی قرار نیست حذف شود
    // secureStorage.clear();
    //localStorage.clear(); // basket baiad pak shavad 
    //localStorage.setItem(config.basketModel + "_DEV", null);
  },
};

export default BasketStorage;